const RATE_LIMIT_PAYLOAD_SUBSTRING = 'Please wait before requesting a new code';

export class VerificationRateLimitError extends Error {
    readonly payload: string;

    constructor(payload: string) {
        super(payload);
        this.name = 'VerificationRateLimitError';
        this.payload = payload;
    }
}

export const isVerificationRateLimitError = (error: unknown): error is VerificationRateLimitError =>
    error instanceof VerificationRateLimitError;

export const isRateLimitPayload = (value: unknown): boolean =>
    typeof value === 'string' && value.includes(RATE_LIMIT_PAYLOAD_SUBSTRING);
